// import React, { useEffect } from "react";
// import EventImg from "../../../../assets/img/event.jpg";
// import useApiRequest from "../../../../Hooks/apiReq";
// import { useNavigate } from "react-router-dom";
// import TitleSection from "../../../../Shared/TitleSection/TitleSection";
// import SpinnerLoader from "../../../../CommonComponets/SpinnerLoader";
// import { useSelector } from "react-redux";

// const UpdatedNews = () => {
//   const { error, loading, recallRequest, response, sendApiRequest } =
//     useApiRequest();
//   const [data, setData] = React.useState([
//     //     {
//     //     CreatedOn: "2025-09-08",
//     //     EventImg: EventImg,
//     //     News: "Film Festival 2025",
//     //     Link: "/events/film-festival-2025",
//     //     StartTime: "12:30 PM",
//     //     EndTime: "10:00 PM",
//     //     Organizer: "IAFM - International Academy of Film and Media",
//     //     OrganizerLink: "/organizers/iafm",
//     //     Location: "Tavern on the Green, New York"
//     // }, {
//     //     CreatedOn: "2025-09-08",
//     //     EventImg: EventImg,
//     //     News: "Film Festival 2025",
//     //     Link: "/events/film-festival-2025",
//     //     StartTime: "12:30 PM",
//     //     EndTime: "10:00 PM",
//     //     Organizer: "IAFM - International Academy of Film and Media",
//     //     OrganizerLink: "/organizers/iafm",
//     //     Location: "Tavern on the Green, New York"
//     // }
//   ]);
//   const navigate = useNavigate();
//   const getUpdatedEventlist = () => {
//     sendApiRequest("POST", "/Dashboard/GetEventList", "", {
//       onSuccess: (res) => {
//         const ParsedData = res?.data?.jsonData
//           ? JSON.parse(res?.data?.jsonData)
//           : [];
//         setData(ParsedData);
//         console.log("GetEventList", ParsedData);
//       },
//       onStatus3: () => {
//         navigate("/login");
//       },
//     });
//   };
//   const appType = useSelector((state) => state?.uiReducers?.appType);
//   useEffect(() => {
//     if (appType === "Business") getUpdatedEventlist();
//   }, []);
//   return (
//     <div className="col-12 col-xl-3 col-xxl-3">
//       {loading && <SpinnerLoader />}
//       <div className="card border h-100 w-100 overflow-hidden">
//         <div className="card-body p-3">
//           <div class="row g-0 pb-2  align-items-end justify-content-between">
//             <div class="col-auto">
//               <h4 class="flex-1 mb-0 text-nowrap p-1">Event Calender</h4>
//             </div>
//           </div>
//           {data?.length > 0 &&
//             data.map((item, index) => (
//               <div
//                 key={index}
//                 className="p-3  border-translucent border-dashed"
//               >
//                 <div className="row g-2">
//                   {/* Event Image */}
//                   <div className="col-3">
//                     <img
//                       className="rounded w-100 object-fit-cover"
//                       src={item?.EventImg || EventImg} // fallback if no image
//                       alt={item?.News || "Event"}
//                     />
//                   </div>
//                   <div className="col-9">
//                     <div className="d-flex flex-between-center">
//                       {/* Created Date */}
//                       <p className="text-warning fs-10 mb-0 fw-bold mb-1">
//                         {item?.EventDateName}
//                       </p>

//                       {/* Time */}
//                       {/* <p className="fs-9 text-body-tertiary fw-bold mb-1">
//                                                 <span className="fa-solid fa-clock text-body-secondary me-1"></span>
//                                                 {item?.StartTime} - {item?.EndTime}
//                                             </p> */}

//                       {/* Dropdown */}
//                       <div className="btn-reveal-trigger">
//                         {/* <button
//                                                     className="btn btn-sm dropdown-toggle dropdown-caret-none transition-none d-flex btn-reveal"
//                                                     type="button"
//                                                     data-bs-toggle="dropdown"
//                                                     data-boundary="window"
//                                                     aria-haspopup="true"
//                                                     aria-expanded="false"
//                                                     data-bs-reference="parent"
//                                                 >
//                                                     <span className="fas fa-ellipsis-h"></span>
//                                                 </button> */}
//                         <div className="dropdown-menu dropdown-menu-end py-2">
//                           <a className="dropdown-item" href="#!">
//                             Edit
//                           </a>
//                           <a className="dropdown-item text-danger" href="#!">
//                             Delete
//                           </a>
//                           <a className="dropdown-item" href="#!">
//                             Download
//                           </a>
//                           <a className="dropdown-item" href="#!">
//                             Report abuse
//                           </a>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Event Title */}
//                     <a
//                       className="text-primary-hover text-body-highlight fw-bold line-clamp-1 lh-base"
//                       href={item?.Link || "#!"}
//                     >
//                       {item?.News}
//                     </a>

//                     {/* Organizer */}
//                     <p className="text-body-secondary text-color fs-9 mb-2">
//                       <a
//                         className="fw-bold text-primary"
//                         href={item?.OrganizerLink || "#!"}
//                       >
//                         {item?.Title}
//                       </a>
//                       <br />
//                       {item?.Descr}
//                     </p>

//                     {/* Location */}
//                     <p className="fs-9  text-body-tertiary fw-bold mb-0">
//                       <span className="fa-solid fa-map-marker-alt text-body-secondary"></span>
//                       {item?.Location}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UpdatedNews;

// import React, { useEffect, useState } from "react";
// import EventImg from "../../../../assets/img/event.jpg";
// import useApiRequest from "../../../../Hooks/apiReq";
// import { useNavigate } from "react-router-dom";
// import SpinnerLoader from "../../../../CommonComponets/SpinnerLoader";
// import { useSelector } from "react-redux";
// import { FaChevronLeft, FaChevronRight } from "react-icons/fa"; // Using react-icons for arrows
// import { TbGridDots } from "react-icons/tb";
// const UpdatedNews = () => {
//   const { loading, sendApiRequest } = useApiRequest();
//   const [data, setData] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0); // For handling the calendar navigation

//   const navigate = useNavigate();
//   const appType = useSelector((state) => state?.uiReducers?.appType);

//   const getUpdatedEventlist = () => {
//     sendApiRequest("POST", "/Dashboard/GetEventList", "", {
//       onSuccess: (res) => {
//         const ParsedData = res?.data?.jsonData
//           ? JSON.parse(res?.data?.jsonData)
//           : [];
//         setData(ParsedData);
//       },
//       onStatus3: () => navigate("/login"),
//     });
//   };

//   useEffect(() => {
//     if (appType === "Business") getUpdatedEventlist();
//   }, []);

//   // Handlers for navigation arrows
//   const handlePrev = () =>
//     setCurrentIndex((prev) => (prev > 0 ? prev - 1 : data.length - 1));
//   const handleNext = () =>
//     setCurrentIndex((prev) => (prev < data.length - 1 ? prev + 1 : 0));

//   const currentItem = data[currentIndex];
//   const currentYear = currentItem?.EventDateName?.split(" ")[2] || "2024";
//   return (
//     <div className="col-12 col-xl-4 col-xxl-3">
//       {loading && <SpinnerLoader />}
//       <div className="card border-0 h-100 w-100 overflow-hidden">
//         <div className="card-body p-3 text-center">
//           {/* Header Section */}
//           <div className="d-flex align-items-center mb-3">
//             <div
//               className="me-2 fw-bold text-dark"
//               style={{ fontSize: "1rem" }}
//             >
//               <TbGridDots /> Event Calendar {currentYear}
//             </div>
//           </div>

//           {/* Navigation Bar */}
//           <div className="d-flex justify-content-between align-items-center mb-4">
//             <button
//               onClick={handlePrev}
//               className="btn btn-light border-0 px-3 py-2 text-secondary"
//             >
//               <FaChevronLeft />
//             </button>

//             <div className="date-display-badge">
//               {currentItem?.EventDateName || "04 Mar 2025"}
//             </div>

//             <button
//               onClick={handleNext}
//               className="btn btn-light border-0 px-3 py-2 text-secondary"
//             >
//               <FaChevronRight />
//             </button>
//           </div>

//           {/* Event Content Section */}
//           {data?.length > 0 ? (
//             <div className="event-content">
//               {/* Event Image - Centered and Square */}
//               <div className="mb-3 d-flex justify-content-center">
//                 <img
//                   className="rounded object-fit-cover shadow-sm"
//                   src={currentItem?.EventImg || EventImg}
//                   alt="Event"
//                   style={{ width: "150px", height: "150px" }}
//                 />
//               </div>

//               {/* Event Title */}
//               <h4 className="fw-bold text-dark mb-1 px-2">
//                 {currentItem?.Title || currentItem?.News}
//               </h4>

//               {/* Description */}
//               <p className="text-muted fs-9 px-3">
//                 {currentItem?.Descr ||
//                   "Discussion about our running task and planning for closing of this financial year"}
//               </p>
//             </div>
//           ) : (
//             <p className="text-muted">No events found.</p>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UpdatedNews;

import React, { useEffect, useState } from "react";
import EventImg from "../../../../assets/img/event.jpg";
import useApiRequest from "../../../../Hooks/apiReq";
import { useNavigate } from "react-router-dom";
import SpinnerLoader from "../../../../CommonComponets/SpinnerLoader";
import { useSelector } from "react-redux";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { TbGridDots } from "react-icons/tb";

const UpdatedNews = () => {
  const { loading, sendApiRequest } = useApiRequest();
  const [data, setData] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const navigate = useNavigate();
  const appType = useSelector((state) => state?.uiReducers?.appType);

  const getUpdatedEventlist = () => {
    sendApiRequest("POST", "/Dashboard/GetEventList", "", {
      onSuccess: (res) => {
        const ParsedData = res?.data?.jsonData
          ? JSON.parse(res?.data?.jsonData)
          : [];
        setData(ParsedData);
      },
      onStatus3: () => navigate("/login"),
    });
  };

  useEffect(() => {
    if (appType === "Business") getUpdatedEventlist();
  }, []);

  const handlePrev = () =>
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : data.length - 1));
  const handleNext = () =>
    setCurrentIndex((prev) => (prev < data.length - 1 ? prev + 1 : 0));

  const currentItem = data[currentIndex];
  // Extract year dynamically or fallback to 2025
  const currentYear = currentItem?.EventDateName?.split(" ").pop() || "2025";

  return (
    <div className="col-12 col-xl-4 col-xxl-3">
      {loading && <SpinnerLoader />}
      <div className="card border-0 h-100 w-100 overflow-hidden shadow-sm">
        <div className="card-body p-3 text-center">
          {/* Header Section */}
          <div className="d-flex align-items-center mb-3">
            <div
              className="me-2 fw-bold  d-flex align-items-center gap-2"
              style={{ fontSize: "1rem" }}
            >
              <TbGridDots className="" /> Event Calendar {currentYear}
            </div>
          </div>

          {/* Navigation Bar with Dashed Style */}
          <div className="d-flex justify-content-between align-items-center mb-4 px-1">
            <button
              onClick={handlePrev}
              className="btn btn-nav-dashed"
              disabled={currentIndex === 0}
              aria-label="Previous"
            >
              <FaChevronLeft size={14} />
            </button>

            <div className="date-display-badge">
              {currentItem?.EventDateName || "Select Date"}
            </div>

            <button
              onClick={handleNext}
              className="btn btn-nav-dashed"
              aria-label="Next"
              disabled={data.length === currentIndex + 1}
            >
              <FaChevronRight size={14} />
            </button>
          </div>

          {/* Event Content Section */}
          {data?.length > 0 ? (
            <div className="event-content animate-fade-in">
              <div className="mb-3 d-flex justify-content-center">
                <img
                  className="rounded-3 object-fit-cover shadow-sm border"
                  src={currentItem?.EventImg || EventImg}
                  alt="Event"
                  style={{ width: "160px", height: "160px" }}
                />
              </div>

              <h4
                className="fw-bolder   mb-1 px-2"
                style={{ fontSize: "1.15rem" }}
              >
                {currentItem?.Title || currentItem?.News}
              </h4>

              <p className=" fs-9 px-3 mt-2 lh-base">
                {currentItem?.Descr ||
                  "No description available for this event."}
              </p>
            </div>
          ) : (
            <div className="py-5 text-muted">No upcoming events.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpdatedNews;
